"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Activity = void 0;
var EntitiesHelper_1 = require("../../helpers/EntitiesHelper");
var Activity = (function () {
    function Activity(name, type, goto, xgoto, pgoto, activities, igoto, condition) {
        this._name = name;
        this._type = type;
        this._goto = goto;
        this._xgoto = xgoto;
        this._igoto = igoto;
        this._pgoto = pgoto;
        this._condition = condition;
        this._activities = activities;
    }
    Object.defineProperty(Activity.prototype, "name", {
        get: function () {
            return this._name;
        },
        set: function (aName) {
            this._name = aName;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Activity.prototype, "type", {
        get: function () {
            return this._type;
        },
        set: function (aType) {
            this._type = aType;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Activity.prototype, "goto", {
        get: function () {
            return this._goto;
        },
        set: function (aGoto) {
            this._goto = aGoto;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Activity.prototype, "xgoto", {
        get: function () {
            return this._xgoto;
        },
        set: function (aXgoto) {
            this._xgoto = aXgoto;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Activity.prototype, "igoto", {
        get: function () {
            return this._igoto;
        },
        set: function (aIgoto) {
            this._igoto = aIgoto;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Activity.prototype, "pgoto", {
        get: function () {
            return this._pgoto;
        },
        set: function (aPgoto) {
            this._pgoto = aPgoto;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Activity.prototype, "activities", {
        get: function () {
            return this._activities;
        },
        set: function (aActivities) {
            this._activities = aActivities;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Activity.prototype, "condition", {
        get: function () {
            return this._condition;
        },
        set: function (aCondition) {
            this._condition = aCondition;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Activity.prototype, "$id", {
        get: function () {
            return EntitiesHelper_1.EntHelper.GetIdFromName(this.name);
        },
        enumerable: false,
        configurable: true
    });
    return Activity;
}());
exports.Activity = Activity;
//# sourceMappingURL=Activity.js.map